export default class Pagination {
  currentPage = null;

  total = null;

  limit = process.env.PLATFORM === 'cabinet' ? 15 : 30;

  totalPages = null;

  loadMoreDisabled = false;

  constructor (pagination) {
    const { page, count, limit } = pagination;

    this.currentPage = page;
    this.total = count;
    this.limit = limit;
    this.totalPages = Math.ceil(count / limit);
    this.loadMoreDisabled = pagination.loadMoreDisabled;
  }

  get nextCount () {
    const totalRest = this.total - this.limit * this.currentPage;
    return totalRest > this.limit ? this.limit : totalRest;
  }

  get showLoadMore () {
    return !this.loadMoreDisabled && this.total > this.limit * this.currentPage;
  }

  get limitStart () {
    if (this.total === 0) return 0;
    return this.currentPage === 1
      ? 1
      : ((this.currentPage - 1) * this.limit) + 1;
  }

  get limitEnd () {
    return this.currentPage >= this.totalPages
      ? this.total
      : this.currentPage * this.limit;
  }

  get currentLimit () {
    return `${this.limitStart}-${this.limitEnd}`;
  }

  get isPrevDisabled () {
    return this.currentPage <= 1;
  }

  get isNextDisabled () {
    return this.currentPage >= this.totalPages;
  }
};
